import { render } from "./TableContainer.vue?vue&type=template&id=6e47b57f&scoped=true&ts=true"
import script from "./TableContainer.ts?vue&type=script&lang=ts"
export * from "./TableContainer.ts?vue&type=script&lang=ts"

import "./TableContainer.css?vue&type=style&index=0&id=6e47b57f&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e47b57f"]])

export default __exports__